import { render, staticRenderFns } from "./normsMaintain.vue?vue&type=template&id=6745e3c0&scoped=true"
import script from "./normsMaintain.vue?vue&type=script&lang=js"
export * from "./normsMaintain.vue?vue&type=script&lang=js"
import style0 from "./normsMaintain.vue?vue&type=style&index=0&id=6745e3c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6745e3c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6745e3c0')) {
      api.createRecord('6745e3c0', component.options)
    } else {
      api.reload('6745e3c0', component.options)
    }
    module.hot.accept("./normsMaintain.vue?vue&type=template&id=6745e3c0&scoped=true", function () {
      api.rerender('6745e3c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/organizationChild/child/normsMaintain.vue"
export default component.exports